import { render, staticRenderFns } from "./Index_phone.vue?vue&type=template&id=768d48bd&scoped=true&"
import script from "./Index_phone.vue?vue&type=script&lang=js&"
export * from "./Index_phone.vue?vue&type=script&lang=js&"
import style0 from "./Index_phone.vue?vue&type=style&index=0&id=768d48bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768d48bd",
  null
  
)

export default component.exports